import React from 'react'
import { Container, Col, Row } from 'reactstrap';
import SignUpForm from "../shared/SignUpFrom";
import Advantages from '../advantages/Advantages';
import './signup.scss'
import { GoogleOAuthProvider } from '@react-oauth/google';

const SignUp = (props) => {
  const googleClientId = window.envs.googleClientId
  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <div className="page signup">
            <section className="content">
              <Container className="signup-container">
                <Row>
                  <Col xs="12" md="6">
                    <div className="signup-col left">
                      <h1 className="page-title account-signup">Start Now, Zero Hassle</h1>
                      <p className="page-subtitle">Start optimizing your remote operations today with instant access to advanced features.</p>
                      <SignUpForm site_key={props.recaptchaKey}/>
                    </div>
                  </Col>
                  <Col xs="12" md="6">
                    <div className="signup-col">
                      <Advantages />
                    </div>
                  </Col>
                </Row>
              </Container>
            </section>
          </div>
    </GoogleOAuthProvider>
   
  )
}

export default SignUp
